import { useState, useEffect } from 'react';
import { configAPI } from '../services/api';

// Reads a specific service's company identity (name/logo/phone) from Settings > Company
// Details — e.g. broadband ("Angel Internet Services") for the technical team's branding,
// vs the catv identity ("Laxmi Cable Vision") used on the agent app. Falls back to the
// other service's identity, then the legacy flat companyName/companyPhone fields, same
// priority AgentLoginPage.js already used for catv.
export function useCompanyIdentity(service) {
  const [identity, setIdentity] = useState({ name: '', logo: '', phone: '', email: '', appUrl: '' });

  useEffect(() => {
    configAPI.get().then(({ data }) => {
      const d = data?.data;
      if (!d) return;
      const primary = d[service];
      const fallback = service === 'broadband' ? d.catv : d.broadband;
      const src = primary?.name ? primary : fallback?.name ? fallback : null;
      setIdentity({
        name: src?.name || d.companyName || '',
        logo: src?.logo || '',
        phone: src?.phone || d.companyPhone || '',
        email: src?.email || '',
        appUrl: d.publicAppUrl || '',
      });
    }).catch(() => {});
  }, [service]);

  return identity;
}
